import { render, staticRenderFns } from "./info-not-a-test.vue?vue&type=template&id=f009bb9c&"
import script from "./info-not-a-test.vue?vue&type=script&lang=js&"
export * from "./info-not-a-test.vue?vue&type=script&lang=js&"
import style0 from "./info-not-a-test.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports